export const OUTSIDE_URLS = {
    TIBCO_CLOUD: "http://cloud.tibco.com",
    TIBCO_CLOUD_PRICING: "http://cloud.tibco.com/cloud-services"
};

export const BASE_CONSTANTS = {
    CONTRIBUTIONS: "/contributions",
    MODULES: "/modules",
    FEATURE: "/feature",
    SERVICES: "/services",
    TCI: "/tci",
    CONNECTORS: "/connectors",
    CONNECTIONS: "/connections",
    APPS: "/apps",
    TAGS: "/tags",
    ACCESS: "/access",
    ACTIONS: "/actions",
    APPROVAL: "/approval",
    VISIBILITY: "/visibility",
    APPLICATIONS: "/applications",
    SANDBOXES_DEFAULT: "/sandboxes/MyDefaultSandbox",
    CONFIGURATION: "/configuration",
    AUTO_SCALE_CONFIG: "/autoscaleconfig",
    AUTO_SCALE_PROP: "/autoscaleprop",
    SYS_PROPERTIES: "/sysproperties",
    TIB_TUNNEL: "/tibtunnel",
    LOGS: "/logs",
    AGENT: "/agent",
    ALERT: "/alert",
    SUPPLEMENT: "/supplement",
    DBSERVICE: "/dbservice",
    HYBRID_DBSERVICE: "/hybriddbservice",
    FLOGO_TESTER: "/flogotester",
    SECURITY: "/security",
    PUBLISH: "/publish",
    MASHERY: "/mashery",
    DOMAIN_SERVER: "/ds",
    API_ORCHESTRATOR: "/ao",
    APP_MANAGER: "/am",
    SCRIBE_UI: "/scribeui",
    LIVEAPPS_UI: "/liveappsui",
    API_MODELER: "/modeler",
    API_MOCK: "/mock",
    MARKETPLACE: "/marketplace",
    VERSION: "/version",
    INTERNAL: "/internal",
    ABOUT: "/build/about",
    UI_SERVICES: "/uiservices",
    SUBSCRIBE: "/subscribe",
    TOOLS: "/tools",
    PRODUCT_VERSION: "/productVersion",
    TOOLS_VERSION: "/toolsVersion",
    WIFLOGO: "/wiflogo",
    WHOAMI: "/whoami",
    USER_CAP: "/usercap",
    USER_PROFILE: "/userprofile",
    USER_LOGOUT: "/logout",
    GLOBAL: "/global",
    ENV_VARS: "/envvars",
    TEST_USERS: "/testusers/login",
    TIME_ZONE: "/timezone",
    VPN: "/vpn",
    DEPLOYER: "/deployer",
    AUDITS: "/audits",
    METRICS: "/metrics",
    MONITOR: "/monitor",
    MONITOR_CALLBACK: "/monitorcallback",
    TENANCY: "/tenancy",
    OWNER: "/owner",
    TSC_USERS: "/tscusers",
    TSC_ORGS: "/tscorgs",
    COPY: "/copy",
    REPLACE: "/replace",
    USERS: "/users",
    ORGS: "/orgs",
    ORGS_V2: "/orgs_v2",
    METADATA: "/metadata",
    STATUS: "/status",
    DELETE_COOKIE: "/deleteCookie",
    UNREGISTERED_ERROR: "unregistered-error",
    TENANTS_NOT_AVAILABLE: "tenants-not-available",
    PAGE_NOT_FOUND: "404-page-not-found",
    DISABLED_ERROR: "disabled-error",
    EULA_ERROR: "eula-error",
    WELCOME_SCREEN: "welcome-screen",
    WS_TMP_UPLOAD: "/tci-webserver/uploads",
    // Deployment
    AO_SCALE: "/ao/app/scale",
    AUGMENT_JWT: "/augment-jwt",
    TCI_DATE_TIME_FORMAT: "dd MMM y h:mm a",
    MARKETPLACE_EULA: "/eula",
    MARKETPLACE_CONTRIBUTOR_AGREEMENT: "/contributor_agreement",
    TIBCLI_PATH: "/tibcli",
    TIBAGENT_PATH: "/tibagent",
    ELASTIC_PATH: "/elastic",
    PRIVATE_ENDPOINT_SWAGGER_BASE_PATH: "/proxy/apps/{appId}/mesh",
    EXTERCOM: "/extercom",
    EXEC_HISTORY: "/exec_history",
    MIGRATION_READY: "migrationReady",
    LEGACY_STATE: "legacyState",
    ASSET: "/asset",
    DOWNLOAD: "/download"
};

export const BASE_URLS = {
    DOMAINSERVER: "/v1",
    DOMAINSERVER_V2: "/v2",
    WEBSERVER: "/api/v1",
    APPMANAGER: "/v1",
    BUILDSERVER: "/v1",
    APIORCHESTRATOR: "/v1",
    APIORCHESTRATOR_V2: "/v2",
    TSC_ORCHESTRATOR_V2: "/v2",
    MASHERYSERVER: "/v1",
    UNITYAPIPROXY: "/v1",
    IDENTITYMANAGEMENT: "/v1",
    WISERVER: "/wistudio/v1",
    MODELER: "/api/v1/modeler",
    NODE: "/v1"
};

export const SERVICE_URLS = {
    APPS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}`,
    MARKETPLACE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}`,
    CONTRIBUTIONS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONTRIBUTIONS}`,
    MODULES: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONTRIBUTIONS}${BASE_CONSTANTS.MODULES}`,
    WHOAMI: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.WHOAMI}`,
    TAGS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TAGS}`,
    USER_PROFILE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.USER_PROFILE}`,
    USER_LOGOUT: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.USER_LOGOUT}`,
    USERCAP: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.USER_CAP}`,
    WIFLOGO: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.WIFLOGO}`,
    PRODUCT_VERSION: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.PRODUCT_VERSION}`,
    ENV_VARS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ENV_VARS}`,
    TIME_ZONE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.TIME_ZONE}`,
    VPN: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SECURITY}${BASE_CONSTANTS.VPN}`,
    TIB_TUNNEL: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SECURITY}${BASE_CONSTANTS.TIB_TUNNEL}`,

    // Deployment
    AM: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APP_MANAGER}`,
    AO: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.API_ORCHESTRATOR}`,
    DEPLOYER: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.DEPLOYER}`,
    DEPLOYER_STATUS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.DEPLOYER}/status`,
    DEPLOYER_STATUS_MULTIPLE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.DEPLOYER}/status_multiple`,

    // Marketplace
    MARKETPLACE_ACTIONS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}/actions`,
    MARKETPLACE_TAGS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}${BASE_CONSTANTS.TAGS}`,
    MARKETPLACE_ORGS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}${BASE_CONSTANTS.ORGS}`,
    MARKETPLACE_EULA: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}${BASE_CONSTANTS.MARKETPLACE_EULA}`,
    MARKETPLACE_CONTRIBUTOR_AGREEMENT: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.MARKETPLACE}${BASE_CONSTANTS.MARKETPLACE_CONTRIBUTOR_AGREEMENT}`,

    // Connectors & Connections
    CONNECTORS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONNECTORS}`,
    CONNECTORS_TCI: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONNECTORS}/tci`,
    CONNECTORS_SCRIBE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONNECTORS}/scribe`,
    CONNECTIONS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.CONNECTIONS}`,

    // Publishing
    PUBLISH: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.PUBLISH}`,

    TENANCY: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.TENANCY}`,
    TENANCY_USERS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.TENANCY}${BASE_CONSTANTS.USERS}`,
    TENANCY_ORGS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.TENANCY}${BASE_CONSTANTS.ORGS}`,
    TENANCY_ORGS_V2: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.TENANCY}${BASE_CONSTANTS.ORGS_V2}`,
    TENANCY_STATUS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.TENANCY}${BASE_CONSTANTS.STATUS}`,

    // Monitoring
    METRICS_DIRECT: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.MONITOR}/direct`,
    METRICS_RECORDS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.MONITOR}/records`,
    METRICS_TESTSTATUS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.MONITOR}/teststatus`,
    METRICS_REGISTER: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.APPS}${BASE_CONSTANTS.MONITOR}/registrations`,

    // Agent
    AGENT_LIST: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.AGENT}/list`,
    AGENT_DEPLOYER_STATUS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.AGENT}/status`,
    AGENT_DELETE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.AGENT}`,
    AGENT_APPS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.AGENT}/apps`,
    AGENT_TUNNEL_SPECS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.AGENT}/tunnelspecs`,

    // Alert
    ALERT_LIST: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ALERT}/list`,
    ALERT_ADD: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ALERT}/add`,
    ALERT_DELETE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ALERT}/delete`,
    ALERT_HOOK: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ALERT}/hook`,
    ALERT_NOTIFICATIONS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.ALERT}/notifications`,

    // Supplement
    SUPPLEMENT_LIST: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SUPPLEMENT}/list`,
    SUPPLEMENT_CONNECTOR: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SUPPLEMENT}/connector`,
    SUPPLEMENT_UPLOAD: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SUPPLEMENT}/upload`,
    SUPPLEMENT_FILE_UPLOAD: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SUPPLEMENT}/file`,
    SUPPLEMENT_UPLOAD_STATUS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SUPPLEMENT}/status`,

    // DB Services
    DB_SERVICE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SECURITY}${BASE_CONSTANTS.DBSERVICE}`,
    HYBRID_DB_SERVICE: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SECURITY}${BASE_CONSTANTS.HYBRID_DBSERVICE}`,

    // Flogo Tester Services
    FLOGO_TESTER: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.SECURITY}${BASE_CONSTANTS.FLOGO_TESTER}`,

    // Elastic logs
    ELASTIC_LOGS: `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.LOGS}${BASE_CONSTANTS.ELASTIC_PATH}`,
};

export const MESSAGING_SUBJECTS = {
    CONTRIB_INIT_SUBJECT: "CONTRIB_INIT_SUBJECT"
};

export const DISCOVERY_SERVICES_URLS = {
    API_MOCK: "/apimock",
    API_MODELER: "/apimodeler",
    API_ORCHESTRATOR: "/orchestrator",
    APP_MANAGER: "/appmgr",
    BUILD_SERVER: "/build",
    BW_SERVER: "/build",
    DOMAIN_SERVER: "/domain",
    MASHERY_SERVER: "/masheryapiproxy",
    DOCS_URL: "/docs/index.html",
    IDENTITY_MANAGEMENT: "/idm",
    MGS: "/tci",
    TSC_ORCHESTRATOR: "/tsc-orchestrator",
    UNITY_API_PROXY: "/unityapiproxy",
    WISTUDIO: "/wistudio",
    SCRIBE: "/scribe",
    SYNERGY: "/synergy",

    // Non-URL values
    ENABLE_ENDPOINT_VISIBILITY: "enable_endpoint_visibility",
    ENABLE_TSC_SIGNUP_FORM: "enable_tsc_signup_form",
    INDEX_URL: "indexUrl",
    REGISTER_URL: "registerUrl",
    REDIRECTION_TIME: "redirectionTime",
    TCI_TENANT_ID: "tciTenantId",
    LOGIN: "login_service",
    ENABLE_TSC_INTEGRATION: "enable_tsc_integration",
    TSC_SIGNUP: "tsc_signup_url",
    LOG_DOWNLOAD_SIZE_LIMIT: "log_download_size_limit",
    REGISTER_USER: "registerUserUrl"
};

export const QUERY_PARAMS = {
    APP_TYPE: "applicationType",
    APP_TYPE_SHORT: "appType",
    APP_NAME: "appName",
    COMPONENT: "component",
    DEFAULT_ROUTE: "default",
    METRICS_REGISTER_APPS: "appIds",
    METRICS_CATEGORY: "category",
    METRICS_IS_MIGRATION_READY: "isMigrationReady",
    METRICS_RANGE_ID: "rangeId",
    INSTANCE_ID: "instanceId",
    ON_PREMISE: "onPremise",
    LAST_AUDIT: "lastAudit",
    SUPPLEMENT_NAME: "supplementName",
    SUBSCRIPTION_ID: "subId",
    LEGACY_STATE: "legacyState",
    MIGRATION_READY: "migrationReady"
};

// For IPAS.-13539
export const ROUTE_REDIRECT_VALS = {
    API_SPECS_ROUTE: "apispecs",
    API_SPECS_REDIRECT: "models/apispecs",
    API_SPECS_RESOLVER: "apiSpecsUrlResolver"
};
